"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const classnames_template_literals_1 = __importDefault(require("@netlify/classnames-template-literals"));
const LoadingComponent_1 = __importDefault(require("components/shared/LoadingComponent"));
const Button = ({ id, variant = 'primary', children, style, disabled = false, isLoading = false, onClick, customClass, onMouseEnter, onMouseLeave, stopPropagation = true, key, alignText = 'center', usePadding = true, onMouseDown, enableClickEvent = true, useMinHeight = true, useRounded = true, backgroundClass = 'bg-transparent', type = 'button' }) => {
    const isDisabled = disabled || isLoading;
    const getVariantClassName = () => {
        if (variant === 'custom')
            return '';
        return (0, classnames_template_literals_1.default)(`
      cursor-pointer
      typography-button
      ${variant === 'primary' &&
            `
          ${usePadding && 'px-[16px]'}
          border-0
          bg-base-600
          text-n-100
          hover:bg-base-500 active:bg-base-500
        `}

      ${variant === 'secondary' &&
            alignText !== 'left' &&
            `
          ${usePadding && 'px-[16px]'}
          border
          border-solid
          border-n-400 bg-n-000 text-n-900
        `}

      ${variant === 'secondary' &&
            alignText === 'left' &&
            `
          border-0
          ${backgroundClass}
        `}

      ${variant === 'tertiary' &&
            !isDisabled &&
            `
          border-0
          ${backgroundClass}
          text-base-600
          ${usePadding && 'px-[8px]'}
        `}

      ${variant === 'danger' &&
            !isDisabled &&
            `
          border-0
          bg-r-600
          px-[16px]
          text-n-100
        `}
      ${(variant === 'secondary' || variant == 'tertiary') &&
            !isDisabled &&
            `hover:bg-base-30024 active:bg-base-30024`}
    `);
    };
    const btnCN = (0, classnames_template_literals_1.default)(`
    flex

    ${alignText === 'left' && `justify-start`}
    ${alignText === 'right' && `justify-end`}
    ${alignText === 'center' && `justify-center`}
    ${useMinHeight && 'min-h-[44px] md:min-h-[32px]'}
    ${useRounded && 'rounded-[8px]'}

    items-center
    whitespace-nowrap
    leading-[16px]

    ${!isDisabled
        ? getVariantClassName()
        : `disabled cursor-not-allowed border-0 ${variant === 'tertiary' ? 'bg-transparent px-[8px]' : 'bg-n-300 px-[16px]'} text-n-600`}

    ${customClass}
  `);
    let onEnterProps = {};
    if (onMouseEnter && onMouseLeave) {
        onEnterProps = {
            onMouseEnter,
            onMouseLeave
        };
    }
    const handleClick = (e) => {
        if (!enableClickEvent)
            return;
        stopPropagation && e.stopPropagation();
        onClick && onClick(e);
    };
    const handleMouseDown = (e) => {
        if (!enableClickEvent || !onMouseDown)
            return;
        stopPropagation && e.stopPropagation();
        onMouseDown(e);
    };
    return (react_1.default.createElement("button", { id: id, key: key || id, className: btnCN, style: { ...style, outline: 'none' }, onClick: (e) => handleClick(e), onMouseDown: handleMouseDown, disabled: isDisabled, "data-cy": id, type: type, ...onEnterProps },
        isLoading && (react_1.default.createElement(LoadingComponent_1.default, { hasText: false, size: 20, className: "mr-[4px] py-[0px]" })),
        children));
};
const Secondary = (props) => {
    return react_1.default.createElement(Button, { variant: "secondary", ...props });
};
const Tertiary = (props) => {
    return react_1.default.createElement(Button, { variant: "tertiary", ...props });
};
const Submit = (props) => {
    const [localDisabled, setLocalDisabled] = (0, react_1.useState)(false);
    const disabled = localDisabled || props.disabled || false;
    const handleClick = async () => {
        setLocalDisabled(true);
        props.onClick && (await props.onClick());
        setLocalDisabled(false);
    };
    return (react_1.default.createElement(Button, { ...props, variant: "primary", onClick: handleClick, disabled: disabled }));
};
Button.Secondary = Secondary;
Button.Tertiary = Tertiary;
Button.Submit = Submit;
exports.default = Button;
